import { IBaseWidget } from './IBaseWidget';

/**
 * Rappresenta i widget che contengno il codice `code`
 * definibile da utente.
 */
export interface ICodeWidget {
  /**
   * Nome univoco dell'elemento, utilizzato per identificarlo all'interno
   * del form.
   */
  code: string;
}

export function hasCode(
  widget: IBaseWidget,
): widget is IBaseWidget & ICodeWidget {
  return 'code' in widget;
}
